import { connect } from 'react-redux';
import { matchesState } from 'xstate';
import { toggleVoterProfile } from 'actionCreators';
import VoterProfileBtn from 'components/buttons/VoterProfileBtn';

const mapStateToProps = ({ user: { firstname, lastname }, machine }) => ({
  user_name: firstname ? `${firstname} ${lastname}` : `${lastname}`,
  isOpen: matchesState('voterProfile.opened', machine),
});

const mapDispatchToProps = (dispatch) => ({
  toggleVoterProfile: () => {
    return dispatch(toggleVoterProfile());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VoterProfileBtn);
